"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MaxHeight = MaxHeight;
var _react = _interopRequireDefault(require("react"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Main component
// -------------------------------------------------------------------------------------------------

function MaxHeight({
  children,
  height
}) {
  return /*#__PURE__*/_react.default.createElement(_styled.StyledComponent, {
    height: height
  }, children);
}